import React from 'react'
import { GridRegular, DocumentRegular, PeopleTeamRegular, TimelineRegular, FlowchartRegular } from '@fluentui/react-icons'
import { skillsMatrixContent } from '../components/skills-matrix/content'
import { spfxShowcaseContent } from '../components/spfx-showcase/content'
import { teamsIntegrationContent } from '../components/teams-integration/content'
import { careerTimelineContent } from '../components/timeline/content'
import { architectureContent } from '../components/architecture/content'

const SkillsMatrix = React.lazy(() => import('../components/skills-matrix/SkillsMatrix'))
const SpfxShowcase = React.lazy(() => import('../components/spfx-showcase/SpfxShowcase'))
const TeamsIntegration = React.lazy(() => import('../components/teams-integration/TeamsIntegration'))
const CareerTimeline = React.lazy(() => import('../components/timeline/CareerTimeline'))
const ArchitectureDiagram = React.lazy(() => import('../components/architecture/ArchitectureDiagram'))

export interface SectionConfig {
	key: string
	title: string
	description: string
	icon: React.ReactElement
	component: React.LazyExoticComponent<React.ComponentType<any>>
}

export const sectionsConfig: SectionConfig[] = [
	// Architecture first: the diagram is the visual table of contents —
	// selecting a node filters the skills matrix directly below it.
	{
		key: 'architecture',
		title: architectureContent.title,
		description: architectureContent.description,
		icon: <FlowchartRegular />,
		component: ArchitectureDiagram
	},
	{
		key: 'skillsMatrix',
		title: skillsMatrixContent.title,
		description: skillsMatrixContent.description,
		icon: <GridRegular />,
		component: SkillsMatrix
	},
	{
		key: 'careerTimeline',
		title: careerTimelineContent.title,
		description: careerTimelineContent.description,
		icon: <TimelineRegular />,
		component: CareerTimeline
	},
	{
		key: 'spfxShowcase',
		title: spfxShowcaseContent.title,
		description: spfxShowcaseContent.description,
		icon: <DocumentRegular />,
		component: SpfxShowcase
	},
	{
		key: 'teamsIntegration',
		title: teamsIntegrationContent.title,
		description: teamsIntegrationContent.description,
		icon: <PeopleTeamRegular />,
		component: TeamsIntegration
	}
]
